"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _Bullets = _interopRequireDefault(require("./Bullets.styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Bullets = function Bullets(_ref) {
  var active = _ref.active,
      counter = _ref.counter,
      onChange = _ref.onChange;
  var css = (0, _Bullets.default)();
  var handleClick = (0, _debounce.default)(function (id) {
    onChange(id);
  }, 300);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)(css.root, "mco-animation-01__bullets")
  }, Array.from({
    length: counter
  }, function (_, i) {
    var _clsx;

    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx2.default)(css.bullet, "mco-animation-01__bullet", (_clsx = {}, _defineProperty(_clsx, css.bulletSelected, active === i), _defineProperty(_clsx, "mco-animation-01__bullet--selected", active === i), _clsx)),
      key: i,
      onClick: function onClick() {
        return handleClick(i);
      }
    });
  }));
};

var _default = Bullets;
exports.default = _default;